var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWeb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "lni_lni-display",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.1,9.4H7.9c-3.4,0-6.1,2.7-6.1,6.1v22.8c0,3.4,2.7,6.1,6.1,6.1h21.9v5.7h-7.9c-1.2,0-2.3,1-2.3,2.3s1,2.3,2.3,2.3h20.4 c1.2,0,2.3-1,2.3-2.3s-1-2.3-2.3-2.3h-7.9v-5.7h21.9c3.4,0,6.1-2.7,6.1-6.1V15.5C62.3,12.1,59.5,9.4,56.1,9.4z M57.8,38.3 c0,0.9-0.7,1.6-1.6,1.6H7.9c-0.9,0-1.6-0.7-1.6-1.6V15.5c0-0.9,0.7-1.6,1.6-1.6h48.3c0.9,0,1.6,0.7,1.6,1.6V38.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeb);
export default __webpack_public_path__ + "static/media/web.17be7719fb2445a5705ab3599c288bd4.svg";
export { ForwardRef as ReactComponent };